import React, { useEffect, useState } from 'react';
import { ApiClientDetails, oauthApi } from '../../apis';
import LoadingOverlay from '../../feedback/LoadingOverlay';
import { Button, IconColor } from '@salvapp/ui-components';
import { showConfirmationModal } from '../../confirmation-modal/confirmationModalReducer';
import { useDispatch } from 'react-redux';
import { showFeedback } from '../../feedback/feedbackReducer';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';

const ApiSecret = () => {
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const [clients, setClients] = useState<ApiClientDetails[]>([]);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setFetching(true);
    const clients = await oauthApi.getClientDetails();
    setClients(clients.clients);
    setFetching(false);
  };

  const createClientCredentials = async () => {
    setFetching(true);
    const client = await oauthApi.createClientDetails();
    setClients([...clients, client]);
    setFetching(false);

    dispatch(
      showConfirmationModal({
        title: 'API client created!',
        description: (
          <div>
            <p>
              Client id: <b>{client.clientId}</b>
            </p>
            <p>
              Secret: <b>{client.clientSecret}</b>
            </p>
          </div>
        ),
        confirmationText: 'Ok',
        icon: faCircleCheck,
        iconColor: IconColor.SUCCESS,
      })
    );
  };

  const deleteClientCredentials = async (client: ApiClientDetails) => {
    dispatch(
      showConfirmationModal({
        title: 'Are you sure?',
        description: 'You are going to delete client credentials',
        confirmationText: 'Yes',
        cancelText: 'No',
        onConfirm: async () => {
          const clientId = client.clientId;
          await oauthApi.deleteClientDetails({ clientId }).then(() => fetchClients());
          dispatch(showFeedback({ message: 'Deleted!' }));
        },
      })
    );
  };

  const renderClientDetails = (client: ApiClientDetails) => {
    return (
      <div className='row align-items-center py-3' key={client.clientId}>
        <div className='col'>
          <h6 className='text-muted mb-2'>Client id</h6>
          <span className='h2 mb-0'>{client.clientId}</span>
        </div>
        <div className='col-auto'>
          <Button variant='outline-danger' size='small' onClick={() => deleteClientCredentials(client)}>
            <i className='fe fe-trash' /> Delete
          </Button>
        </div>
      </div>
    );
  };

  return (
    <LoadingOverlay loading={fetching}>
      {clients.map((client) => renderClientDetails(client))}

      <div className='row align-items-center py-3'>
        <div className='col'>
          <Button variant='secondary' onClick={() => createClientCredentials()} className='mt-3'>
            <i className='fe fe-plus-circle' /> Create API client credentials
          </Button>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default ApiSecret;
